import { z } from 'zod';
import { EProductClassification } from '@/src/shared/enums/product-classification';

export const SOutletListService = z.object({
  min_price: z.number().optional().nullable(),
  max_price: z.number().optional().nullable(),
  lokasi: z.array(z.string()).optional().nullable(),
  search: z.string().optional().nullable(),
  longitude: z.number().optional(),
  latitude: z.number().optional(),
  price_sort: z.string().optional(),
  offset: z.number().optional(),
  size: z.number().optional(),
});

export type TOutletListService = z.infer<typeof SOutletListService>;

export const SProductListService = z.object({
  min_price: z.number().nullable().optional(),
  max_price: z.number().nullable().optional(),
  lokasi: z.array(z.string()).nullable().optional(),
  search: z.string().nullable().optional(),
  longitude: z.number().optional(),
  latitude: z.number().optional(),
  order_by: z.string().optional(),
  offset: z.number().optional(),
  size: z.number().optional(),
  is_not_ethical: z.boolean().nullable().optional(),
});

export type TProductListService = z.infer<typeof SProductListService>;

export const SConsultListService = z.object({
  min_price: z.number().nullable().optional(),
  max_price: z.number().nullable().optional(),
  lokasi: z.array(z.string()).optional().nullable(),
  search: z.string().nullable().optional(),
  longitude: z.number().optional(),
  latitude: z.number().optional(),
  order_by: z.string().optional(),
  offset: z.number().optional(),
  size: z.number().optional(),
  service_method: z.array(z.string()).optional().nullable(),
  payment_method: z.array(z.string()).optional().nullable(),
  min_date: z.string().optional().nullable(),
  max_date: z.string().optional().nullable(),
});

export type TConsultListService = z.infer<typeof SConsultListService>;

export const SProvinceService = z.object({
  province_code: z.string(),
  province_name: z.string(),
  province_longitude: z.number(),
  province_latitude: z.number(),
});

export type TProvinceService = z.infer<typeof SProvinceService>;

export const SProductVariantDetail = z.object({
  id: z.number(),
  weight: z.number().nullable(),
  qty_convertion: z.number(),
  is_small_unit: z.boolean(),
  unit_name: z.string(),
  price_per_unit: z.number(),
  final_price_per_unit: z.number(),
  price_string: z.string(),
  final_price_string: z.string(),
  stock: z.number(),
  ppn: z.number(),
  max_orderable_quantity: z.number(),
});
export const SProductDetail = z.object({
  id: z.number(),
  nie: z.string().nullable(),
  description: z.string().nullable(),
  product_name: z.string(),
  outlet_id: z.number(),
  branch_id: z.number(),
  branch_name: z.string(),
  branch_point_name: z.string(),
  branch_logo: z.string().nullable(),
  branch_city: z.string().nullable(),
  branch_user_phone_number: z.string().nullable(),
  pro_code: z.string().nullable(),
  product_category: z.string().nullable(),
  composition: z.string().nullable(),
  image: z.array(z.string()).nullable(),
  golongan_obat: z.string().pipe(z.enum(EProductClassification)).nullable(),
  is_ethical: z.boolean(),
  expired_date: z.string().nullable(),
  max_price: z.number().nullable(),
  min_price: z.number().nullable(),
  final_max_price: z.number().nullable(),
  final_min_price: z.number().nullable(),
  price_range: z.string().nullable(),
  final_price_range: z.string().nullable(),
  outlet_longitude: z.number().nullable(),
  outlet_latitude: z.number().nullable(),
  aggregate_id: z.number().nullable(),
  dosage_form: z.string().nullable(),
  location: z.string().nullable(),
  star_rating: z.number(),
  review_count: z.number(),
  transaction_count: z.number(),
  max_selling_quantity_in_marketplace: z.number().nullable(),
  min_selling_quantity_in_marketplace: z.number().nullable(),
  small_unit_sale_name: z.string().nullable(),
});

export const SProductDetailResponse = z.object({
  item: SProductDetail,
  products: z.array(SProductVariantDetail),
});

export type TProductVariantDetail = z.infer<typeof SProductVariantDetail>;
export type TProductDetail = z.infer<typeof SProductDetail>;
export type TProductDetailResponse = z.infer<typeof SProductDetailResponse>;
